import { render } from "./EditProductPage.vue?vue&type=template&id=2c73584a&ts=true"
import script from "./EditProductPage.vue?vue&type=script&lang=ts"
export * from "./EditProductPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__